import { createContext, useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useGetLastCustomerSubscription } from '../generated/graphql'

export const LastCustomerContext = createContext<[any, boolean]>([null, true])

export const LastCustomerContextProvider = ({ children }) => {
  const customerId = window.location.pathname?.split('/')?.pop()
  const [fetchingSubscription, setFetchingSubscription] = useState(true)
  const handleSubscription = (_, response) => response?.checkinCustomer

  const [res] = useGetLastCustomerSubscription(
    { variables: { customerId } },
    handleSubscription
  )

  useEffect(() => {
    if (res.fetching) {
      setFetchingSubscription(res.fetching)
    }
  }, [res?.fetching])

  useEffect(() => {
    setFetchingSubscription(res.fetching)
  }, [res?.data])

  console.log('sub', res)

  return (
    <LastCustomerContext.Provider value={[res, fetchingSubscription]}>
      {children}
    </LastCustomerContext.Provider>
  )
}

export const useLastCustomer = () => useContext(LastCustomerContext)
